// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.popover-image {
  float:left;
  margin-right: 10px;
  margin-bottom: 4px;
  max-width: 245px;
}
.popover {
  padding-bottom:10px;
}
.popover-body {
  padding-bottom:0px;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.popover-body ul {
  padding-left: 10px;
}
#main-flex-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* modifications to Bootstrap style */
.btn-group {
  padding-left: 0px;
  padding-right: 0px;
}
.btn-group>.dropdown:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group>.dropdown:nth-child(n+3)>.btn, .btn-group>:not(.btn-check)+.dropdown>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.dropdown-menu>li>.btn {
  border-radius: 0;
}
.dropdown-menu>li>div>ul>li>.btn {
  border-radius: 0;
}
.mobile-dropdown>ul {
  list-style-type: none;
  padding-left: 0;
}
.mobile-dropdown>ul>li>.btn {
  border-radius: 0;
}
.mobile-dropdown>ul>li>div>ul>li>.btn {
  border-radius: 0;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1040;
}

/* Make selected tool dropdown look like a selected radio button */
.btn.selected {
  background-color: #0a58ca;
  color: white;
}
.btn.selected {
  background-color: #0a58ca;
  color: white;
}
.title {
  font-size: 10pt;
  color: rgba(0, 0, 0, 0.5);
}
#help-dropdown {
  width:300px;
  background: rgb(64, 64, 64);
  color: white;
  max-height: 80vh;
  overflow-y: auto
}
#help-dropdown a {
  color: #a9ccff;
  text-decoration: none;
}
#help-dropdown a:hover {
  color: #bdd6f9;
  text-decoration: underline;
}
#welcome_instruction a:hover {
  color: #3685f9 !important;
  text-decoration: underline !important;
}
::-webkit-scrollbar {
  background: none;
  width: 12px;
  height: 12px;
}
::-webkit-scrollbar-thumb {
   border: solid 0 rgba(0, 0, 0, 0);
   border-right-width: 4px;
   border-left-width: 4px;
   -webkit-border-radius: 6px 2px;
   -webkit-box-shadow:
   inset 0 0 0 0px rgba(112, 112, 112, 0.35),
   inset 0 0 0 4px rgba(112, 112, 112, 0.35);
}
::-webkit-scrollbar-track-piece {
   margin: 4px 0;
}
::-webkit-scrollbar-thumb:hover {
    border-right-width: 3px;
    border-left-width: 3px;
   -webkit-box-shadow:
     inset 0 0 0 0px rgba(128,128,128,0.9),
     inset 0 0 0 4px rgba(128,128,128,0.9);
}
::-webkit-scrollbar-corner {
   background: transparent;
}
.ace_scrollbar-h{
  margin: 0 2px
}

/* Custom syntax highlighting for math.js template expressions */
.ace_support.ace_function {
  color: #d4ffa9 !important;
}

/* Fix bracket highlighting visibility for GitHub Dark theme */
.ace-github-dark .ace_marker-layer .ace_bracket {
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 0 !important;
  background: none !important;
}
.ace-github-dark .ace_marker-layer .ace_bracket-start {
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 0 !important;
  background: none !important;
}

/* Fix variable name highlighting visibility for GitHub Dark theme */
.ace-github-dark .ace_marker-layer .ace_selected-word {
  border: none !important;
  border-radius: 0 !important;
  background: rgba(255, 255, 255, 0.2) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/App.vue"],"names":[],"mappings":";AA0EA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,qCAAqC;AAErC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA,kEAAkE;AAElE;EACE,yBAAyB;EACzB,YAAY;AACd;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AAGA;EACE,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB;AACF;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;GACG,gCAAgC;GAChC,uBAAuB;GACvB,sBAAsB;GACtB,8BAA8B;GAC9B;;4CAEyC;AAC5C;AACA;GACG,aAAa;AAChB;AACA;IACI,uBAAuB;IACvB,sBAAsB;GACvB;;0CAEuC;AAC1C;AACA;GACG,uBAAuB;AAC1B;AACA;EACE;AACF;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,2BAA2B;AAC7B;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":["<!--\n  Copyright 2025 The Ray Optics Simulation authors and contributors\n\n  Licensed under the Apache License, Version 2.0 (the \"License\");\n  you may not use this file except in compliance with the License.\n  You may obtain a copy of the License at\n\n      http://www.apache.org/licenses/LICENSE-2.0\n\n  Unless required by applicable law or agreed to in writing, software\n  distributed under the License is distributed on an \"AS IS\" BASIS,\n  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n  See the License for the specific language governing permissions and\n  limitations under the License.\n-->\n\n<template>\n  <CanvasContainer />\n  <WelcomeMessage />\n  <Sidebar />\n  <StatusArea />\n  <Toolbar />\n  <ObjBar />\n  <SimulatorControls />\n  <Footer />\n  <ModuleModal />\n  <SaveModal />\n  <ColorModeModal />\n  <ThemeModal />\n  <LanguageModal />\n\n  <input type=\"file\" id=\"openfile\" style=\"display:none\">\n</template>\n\n<script>\n/**\n * @module App\n * @description The Vue component for the entire web application.\n */\nimport CanvasContainer from './CanvasContainer.vue';\nimport WelcomeMessage from './WelcomeMessage.vue';\nimport Sidebar from './Sidebar.vue';\nimport StatusArea from './StatusArea.vue';\nimport Toolbar from './toolbar/Toolbar.vue';\nimport ObjBar from './ObjBar.vue';\nimport SimulatorControls from './SimulatorControls.vue';\nimport Footer from './Footer.vue';\nimport ModuleModal from './ModuleModal.vue';\nimport SaveModal from './SaveModal.vue';\nimport ColorModeModal from './ColorModeModal.vue';\nimport ThemeModal from './ThemeModal.vue';\nimport LanguageModal from './LanguageModal.vue';\n\n\nexport default {\n  components: {\n    CanvasContainer,\n    WelcomeMessage,\n    Sidebar,\n    StatusArea,\n    Toolbar,\n    ObjBar,\n    SimulatorControls,\n    Footer,\n    ModuleModal,\n    SaveModal,\n    ColorModeModal,\n    ThemeModal,\n    LanguageModal\n  }\n}\n</script>\n\n<style>\n.popover-image {\n  float:left;\n  margin-right: 10px;\n  margin-bottom: 4px;\n  max-width: 245px;\n}\n\n.popover {\n  padding-bottom:10px;\n}\n\n.popover-body {\n  padding-bottom:0px;\n  max-height: 80vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.popover-body ul {\n  padding-left: 10px;\n}\n\n#main-flex-wrapper {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* modifications to Bootstrap style */\n\n.btn-group {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.btn-group>.dropdown:not(:last-child)>.btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group>.dropdown:nth-child(n+3)>.btn, .btn-group>:not(.btn-check)+.dropdown>.btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-menu>li>.btn {\n  border-radius: 0;\n}\n\n.dropdown-menu>li>div>ul>li>.btn {\n  border-radius: 0;\n}\n\n.mobile-dropdown>ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.mobile-dropdown>ul>li>.btn {\n  border-radius: 0;\n}\n\n.mobile-dropdown>ul>li>div>ul>li>.btn {\n  border-radius: 0;\n}\n\n.modal-backdrop {\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 1040;\n}\n\n/* Make selected tool dropdown look like a selected radio button */\n\n.btn.selected {\n  background-color: #0a58ca;\n  color: white;\n}\n\n.btn.selected {\n  background-color: #0a58ca;\n  color: white;\n}\n\n\n.title {\n  font-size: 10pt;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n#help-dropdown {\n  width:300px;\n  background: rgb(64, 64, 64);\n  color: white;\n  max-height: 80vh;\n  overflow-y: auto\n}\n\n#help-dropdown a {\n  color: #a9ccff;\n  text-decoration: none;\n}\n\n#help-dropdown a:hover {\n  color: #bdd6f9;\n  text-decoration: underline;\n}\n\n#welcome_instruction a:hover {\n  color: #3685f9 !important;\n  text-decoration: underline !important;\n}\n\n::-webkit-scrollbar {\n  background: none;\n  width: 12px;\n  height: 12px;\n}\n::-webkit-scrollbar-thumb {\n   border: solid 0 rgba(0, 0, 0, 0);\n   border-right-width: 4px;\n   border-left-width: 4px;\n   -webkit-border-radius: 6px 2px;\n   -webkit-box-shadow:\n   inset 0 0 0 0px rgba(112, 112, 112, 0.35),\n   inset 0 0 0 4px rgba(112, 112, 112, 0.35);\n}\n::-webkit-scrollbar-track-piece {\n   margin: 4px 0;\n}\n::-webkit-scrollbar-thumb:hover {\n    border-right-width: 3px;\n    border-left-width: 3px;\n   -webkit-box-shadow:\n     inset 0 0 0 0px rgba(128,128,128,0.9),\n     inset 0 0 0 4px rgba(128,128,128,0.9);\n}\n::-webkit-scrollbar-corner {\n   background: transparent;\n}\n.ace_scrollbar-h{\n  margin: 0 2px\n}\n\n/* Custom syntax highlighting for math.js template expressions */\n.ace_support.ace_function {\n  color: #d4ffa9 !important;\n}\n\n/* Fix bracket highlighting visibility for GitHub Dark theme */\n.ace-github-dark .ace_marker-layer .ace_bracket {\n  border: 1px solid rgba(255, 255, 255, 0.5) !important;\n  border-radius: 0 !important;\n  background: none !important;\n}\n\n.ace-github-dark .ace_marker-layer .ace_bracket-start {\n  border: 1px solid rgba(255, 255, 255, 0.5) !important;\n  border-radius: 0 !important;\n  background: none !important;\n}\n\n/* Fix variable name highlighting visibility for GitHub Dark theme */\n.ace-github-dark .ace_marker-layer .ace_selected-word {\n  border: none !important;\n  border-radius: 0 !important;\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
